<div *ngFor="let levelData of levelData; let i = index;" class="tree-root tree-child tree-node">
    <div class="line-to"></div>
    <div class="tree-element-container tree-element-has-children">
        <div class="tree-element-main" [dndDraggable]="levelData" [dndEffectAllowed]="draggable.effectAllowed"
            [dndDisableIf]="draggable.disable" dndDropzone (dndDrop)="onDrop($event, levelData)">
            <div class="rect" [ngClass]="{
                    'bubble-selected': levelData.deleted == 0 && !parentRecord,
                    'bubble-deselected': levelData.deleted == 1,
                    'pointer-cursor': !(level == lastNode || !(levelData.deleted == 0) || !(levelData.children != null && levelData.children[0] != undefined)),
                    'default-cursor': level == lastNode || !(levelData.deleted == 0) || !(levelData.children != null && levelData.children[0] != undefined),
                    'bubble-parent': levelData.deleted == 0 && parentRecord
                }">
                <div class="buttons">
                    <div *ngIf="!standerdSubScription || premierSubcription && level < 2">
                        <span class="context-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Action">
                            <mat-icon>menu</mat-icon>
                        </span>
                        <mat-menu #menu="matMenu">
                            <span mat-menu-item (click)="addUser(levelData)" *ngIf="levelData.deleted == 0">
                                <mat-icon>account_box</mat-icon> <span class="menu-icons">Add
                                    User</span>
                            </span>
                            <span mat-menu-item (click)="addChild(levelData)"
                                *ngIf="levelData.deleted == 0 && levelData.level < 4">
                                <mat-icon>account_circle</mat-icon> <span class="menu-icons">Add
                                    Child</span>
                            </span>
                            <span mat-menu-item (click)="deletedHierarchy(levelData)" *ngIf="levelData.level != 1">
                                <mat-icon>delete_forever</mat-icon> <span class="menu-icons">Remove</span>
                            </span>
                        </mat-menu>
                    </div>
                    <div (click)="showNetwork(levelData)"
                        *ngIf="!(level == lastNode) && !levelData.deleted && levelData.deleted == 0"
                        class="button-border"
                        [ngClass]="{'toggler' : levelData.children != null && levelData.children[0] != undefined}">
                    </div>
                </div>
                <div class="classContent">
                    <!-- <span class="ic mb-2">
                        <i [attr.class]="levelData.icon"></i>
                    </span>
                    <br> -->
                    <span class="divText" style="word-wrap: break-word !important; ">{{ levelData.customerName }}</span>
                </div>
            </div>
        </div>
        <div class="tree-children" *ngIf="levelData.customerKey == levelKey && levelData.deleted == 0">
            <div class="tree-elements-group">
                <bubble-tree-ui [levelData]="levelData.children" [level]="level" [addNode]="addNode"
                    [editNode]="editNode" [delNode]="delNode" [isActiveNode]="levelData.deleted == 0"
                    [disableDragDrop]="disableDragDrop" [lastNode]="lastNode" [isSelected]="isSelected"
                    (callEvent)="callEventFunction($event)"
                    *ngIf="levelData.children != null && levelData.children[0] != undefined">
                </bubble-tree-ui>
            </div>
        </div>
    </div>
</div>